import React from "react";
import { useRef } from "react";
import useOnClickOutside from "hooks/useOnClickOutside";
import "./confirmation-modal.scss";

const ConfirmationModal = (props) => {
  const refDelivery = useRef();
  const { isShow, onClose, onClear } = props;

  useOnClickOutside(refDelivery, () => onClose());

  return (
    <>
      {isShow && (
        <>
          <div className="modal-backdrop">
            <div className="modal store-selector-modal" ref={refDelivery}>
              <div className="cancel-order-modal-body">
                <h3>Are you sure you want to cancel the order?</h3>
                <div>
                  <button
                    className="button-outline"
                    type="button"
                    onClick={onClose}
                  >
                    <span>No</span>
                  </button>
                  <button
                    className="button-primary"
                    onClick={() => {
                      onClear();
                      onClose();
                    }}
                  >
                    <span>Yes</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ConfirmationModal;
